import React, { useEffect, useState } from 'react';

// Components
import WpDayPickerDropdown, { WpDayPickerDropdownProps } from './WpDayPickerDropdown';
import WpTextField from '../text-field/WpTextField';

interface Props extends WpDayPickerDropdownProps {
  id: string;
  label?: string;
  placeholder?: string;
  disabled?: boolean;
  labelHidden?: boolean;
  onClear?: Function;
  qaTest?: string;
}

const WpDayPickerInput = ({
  id,
  label = 'Select date',
  placeholder,
  selected,
  onSelect,
  disabled,
  labelHidden,
  onClear,
  disabledDays,
  qaTest,
}: Props) => {
  const [date, setDate] = useState<Date>(null);

  const textValue = date ? `${date.getMonth() + 1}/${date.getDate()}/${date.getFullYear()}` : '';

  const handleSelect = selected => {
    setDate(selected);
    if (onSelect) onSelect(selected);
  };

  const handleOnClear = () => {
    setDate(null);
    onClear && onClear();
  };

  useEffect(() => {
    setDate(selected);
  }, [selected]);

  const Input = () => (
    <WpTextField
      id={id}
      label={label}
      placeholder={placeholder}
      prefixIcon="calendar-alt"
      readOnly
      value={textValue}
      onClear={date && handleOnClear}
      disabled={disabled}
      labelHidden={labelHidden}
      qaTest={qaTest}
    />
  );

  return (
    <WpDayPickerDropdown
      components={{ inner: Input }}
      onSelect={handleSelect}
      selected={date}
      disabledDays={disabledDays}
      qaTest={`${qaTest}-dropdown`}
    />
  );
};

export default WpDayPickerInput;
